import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import ProductSlider from './shop-components/product-slider-v1';
import Tamb1 from './completed-components/tamb01-info';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const Tamb01 = () => {
    return <div>
        <Navbar />
        {/* <PageHeader headertitle="Product Details" customclass="mb-0" /> */}
        {/* <ProductSlider /> */}
        <Tamb1 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Tamb01

